const API_URL = process.env.REACT_APP_API_URL || ''
const MAP_API_URL = process.env.REACT_APP_MAP_API_URL || ''
const CHECK_URL = API_URL.replace('://api.', '://check.')

export { API_URL, MAP_API_URL, CHECK_URL }
